import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography, Grid } from '@material-ui/core';
import { inject, observer } from 'mobx-react';

import Greeting from '../../components/Greeting';
import PageTitle from '../../components/PageTitle';
import ProductCard from '../../components/ProductCard';
import AddressAlert from '../../components/AddressAlert';
import Loading from '../../components/Loading';
import AvailableDatesList from '../../containers/AvailableDatesList';
import SchedulingForm from '../../containers/SchedulingForm';

import RouterStore from '../../stores/RouterStore';
import SchedulingStore from '../../stores/SchedulingStore';
import AvailableDatesStore from '../../stores/AvailableDatesStore';

import { scheduleAssemblyStyles } from './styles';

const ScheduleAssembly = props => {
  const { routerStore, schedulingStore, availableDatesStore } = props;
  const { isLoading, data } = schedulingStore;
  const { dates, hasUnavailableTechniciansError } = availableDatesStore;

  const classes = scheduleAssemblyStyles(props);
  const myRef = useRef();

  useEffect(() => {
    async function fetchScheduleDetails() {
      await schedulingStore.getScheduleDetailsV2(
        routerStore.location.state.uuids
      );

      const integrationIds = data.schedules.map(
        schedule => schedule.integrationId
      );

      await availableDatesStore.getAvailableDatesV2(integrationIds);
    }

    fetchScheduleDetails();
  }, [props, routerStore, schedulingStore, availableDatesStore, data]);

  const scrollToErrorMessage = () =>
    window.scrollTo({ behavior: 'smooth', top: myRef.current.offsetTop });

  return (
    <>
      {isLoading && <Loading />}

      <Box mt={5} mb={12}>
        <Container>
          <Greeting name={data.customer.name} />
          <PageTitle title="Agendar montagem" />

          <Box>
            <Typography component="div">
              <Box fontSize={21} fontWeight="bold">
                1. Confira os detalhes da compra
              </Box>
            </Typography>

            {data.customer && data.schedules.length > 0 && (
              <Grid container>
                <Grid item xs={12} md={6} className={classes.productListBox}>
                  <Typography component="div">
                    <Box fontSize={16} fontWeight="bold">
                      Produtos
                    </Box>
                  </Typography>
                  {data.schedules.map(item => (
                    <ProductCard key={item.id} product={item.product} />
                  ))}
                </Grid>
                <Grid item xs={12} md={6} className={classes.customerDataBox}>
                  {data.customer.address && (
                    <Typography component="div">
                      <Box fontSize={16} fontWeight="bold">
                        Endereço da montagem:
                      </Box>
                      <Box fontSize={16}>{data.customer.address}</Box>
                    </Typography>
                  )}

                  <AddressAlert />
                </Grid>
              </Grid>
            )}

            <Box my={8} ref={myRef}>
              <Typography component="div">
                <Box fontSize={21} fontWeight="bold">
                  2. Escolha uma data
                </Box>
                <Box fontSize={16}>
                  A montagem do seu produto será feita na data escolhida, no
                  período comercial.
                </Box>
              </Typography>

              <AvailableDatesList />

              {dates.length > 0 && !hasUnavailableTechniciansError && (
                <SchedulingForm
                  scrollToErrorMessage={scrollToErrorMessage}
                  customer={data.customer}
                  schedules={data.schedules}
                />
              )}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

ScheduleAssembly.propTypes = {
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
  schedulingStore: PropTypes.instanceOf(SchedulingStore).isRequired,
  availableDatesStore: PropTypes.instanceOf(AvailableDatesStore).isRequired,
};

export default inject(
  'routerStore',
  'schedulingStore',
  'availableDatesStore'
)(observer(ScheduleAssembly));
